module.exports = {"retryLogin.modal.content.text":"Une vérification a été envoyée à votre email. Pour terminer l'activation, cliquez sur le lien de vérification dans l'email, puis revenez à cette page et réessayez.","retryLogin.modal.content.action.buttonLabel":"Réessayez maintenant"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr/components/ModalContent/RetryLogin.json
// module id = 800
// module chunks = 0